<template>
  <div>
    <div class="idb-block">
      <div class="idb-block-title">
        <h2>
          Users
          <help-icon docPath="/administration/users/" />
          <favourite-icon />
        </h2>
      </div>
      <div class="idb-block-content">
        <vue-good-table
          :paginationOptions="paginationOptions"
          :sort-options="sortOptions"
          :isLoading.sync="isTableLoading"
          :rows="rows"
          :columns="columns"
          :lineNumbers="true"
          mode="remote"
          :totalRows="totalRecords"
          @on-row-click="onRowClick"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-column-filter="onColumnFilter"
          @on-per-page-change="onPerPageChange"
          @on-search="onSearch"
          styleClass="vgt-table striped bordered"
          ref="table"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'enabled'">
              <tick v-model="props.row.enabled"></tick>
            </span>
            <span v-else-if="props.column.field == 'lockoutEnd'">
              <span v-if="new Date(props.row.lockoutEnd) < new Date()"></span>
              <span v-else>{{props.formattedRow[props.column.field]}}</span>
            </span>
            <span v-else>{{props.formattedRow[props.column.field]}}</span>
          </template>
          <div slot="table-actions">
            <table-actions
              :print-enabled="false"
              :export-enabled="false"
              :reload-table="load"
              :clear-table-filters="clearTableFilters"
              :create-enabled="true"
              :create="createUser"
              create-tooltip="Create a new user"
            ></table-actions>
          </div>
        </vue-good-table>
      </div>
      <div class="idb-block-footer">
        <button
          class="btn btn-primary"
          @click="createUser"
          type="button"
          :disabled="disabledDueToConnectedMerchant"
        >
          <i class="fa fa-plus rpad"></i>Create User
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// Third Party
import axios from 'axios'
import { mapGetters } from 'vuex'

// Mixins
import tableFilterMixin from '@/Assets/Mixins/TableFilterMixin'
import ConnectedMerchantReadOnlyMixin from '@/Assets/Mixins/ConnectedMerchantReadOnlyMixin'

// Constants
import roles from '@/Assets/Constants/roles'

var checkRights = (store) => {
  if (store.getters.selectedCustomer !== process.env.VUE_APP_LANDZ_ID) {
    if (!store.getters.isInRoles([roles.Limited, roles.ReadOnly, roles.Standard, roles.ClientAdmin, roles.LZAdmin, roles.Finance, roles.DevOps, roles.Qa, roles.Developer, roles.Implementations])) {
      store.commit('setUnauthorized', true)
      return false
    }
  } else {
    if (!store.getters.isInRoles([roles.DevOps, roles.Qa, roles.Developer])) {
      store.commit('setUnauthorized', true)
      return false
    }
  }
  return true
}

export default {
  mixins: [tableFilterMixin, ConnectedMerchantReadOnlyMixin],
  computed: {
    ...mapGetters(['selectedCustomer'])
  },
  data () {
    return {
      rows: [],
      columns: [
        {
          label: 'Name',
          field: 'name',
          filterOptions: {
            enabled: true
          }
        },
        {
          label: 'Phone Number',
          field: 'phoneNumber',
          filterOptions: {
            enabled: true
          },
          sortable: false
        },
        {
          label: 'Username',
          field: 'userName',
          filterOptions: {
            enabled: true
          }
        },
        {
          label: 'Email',
          field: 'email',
          filterOptions: {
            enabled: true
          }
        },

        {
          label: 'Locked Until',
          field: 'lockoutEnd',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss.SSSXXX',
          dateOutputFormat: 'do MMMM yyyy HH:mm:ss'
        },
        {
          label: 'Last Login',
          field: 'lastLogin',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss.SSSXXX',
          dateOutputFormat: 'do MMMM yyyy HH:mm:ss'
        },
        {
          label: 'Enabled',
          field: 'enabled',
          type: 'bool',
          tdClass: 'text-center'
        }
      ],
      serverParams: {
        sort: [{ field: 'email', type: 'asc' }]
      }
    }
  },
  watch: {
    selectedCustomer () {
      this.load()
    }
  },
  methods: {
    onRowClick (params) {
      var userId = params.row.id
      this.$router.push({ name: 'UserEdit', params: { userId } })
    },
    createUser () {
      this.$router.push({ name: 'UserCreate' })
    },
    async load () {
      if (!checkRights(this.$store)) {
        return
      }

      try {
        this.isTableLoading = true

        const response = await axios.get(`${process.env.VUE_APP_PLATFORM_API_URL}users`, { params: { ...this.buildGoodTableQuery(), paygateid: this.selectedCustomer }, showerror: true, errormessage: 'Failed loading users' })
        this.rows = response.data.data
        this.totalRecords = response.data.count
      } finally {
        this.isTableLoading = false
      }
    }

  },
  beforeCreate () {
    checkRights(this.$store)
  }
}

</script>
